import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerPrazo = styled(motion.div)`
    min-width: 280px;
    width: 280px;
    height: 230px;
    border-radius: 10px;
    background: #fff;
    box-sizing: border-box;
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;

    p.Prazo__title {
        font-weight: 600;
        color: var(--text-color);
        width: 100%;
    }

    div.Prazo__chart {
        width: 100%;
        height: 155px;
        margin-top: -15px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    div.Prazo__labels {
        width: 100%;
        display: flex;
        justify-content: space-between;
        gap: 10px;
        margin-top: 10px;

        div.Prazo__labels__item {
            display: flex;
            align-items: center;
            gap: 5px;

            div.Prazo__labels__item__circle {
                width: 12px;
                min-width: 12px;
                height: 12px;
                min-height: 12px;
                background: var(--primary-color);
                border-radius: 100%;
            }

            span.Prazo__labels__item__lebel {
                font-size: 11px;
                white-space: nowrap;
                color: var(--text-color);
                font-weight: 500;
            }
        }
    }
`;